import { lazy } from 'react';

const LazyProjectSpace = lazy(() => import('./project-space'));
export default LazyProjectSpace;
